<template>
  <form action="">
    <b-card
      header="Comprobantes Emitidos"
      header-tag="header"
      class="bold-header mt-3"
      header-bg-variant="gray_ligth"
    >
      <div class="form-row">
        <b-table
          id="my-table"
          :items="filtrodatospro"
          :fields="fields"
          per-page="50"
          smal
          class="table table-hover table-sm"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(actions)="row">
            <a :href="row.item.download_pdf" target="_blank">
              <b-button
                size="sm"
                variant="primary"
                class="mr-1 "
                style="font-size: 10px;"
              >
                PDF
              </b-button>
            </a>
            <a :href="row.item.download_xml" target="_blank">
              <b-button
                size="sm"
                variant="success"
                class="mr-1 "
                style="font-size: 10px;"
              >
                XML
              </b-button>
            </a>
            <a :href="row.item.download_cdr" target="_blank">
              <b-button
                size="sm"
                variant="danger"
                class="mr-1 "
                style="font-size: 10px;"
              >
                CDR
              </b-button>
            </a>
          </template>
        </b-table>
      </div>
    </b-card>
  </form>
</template>

<script>
//import axios from "axios";
//import { mapMutations, mapActions, mapState } from "vuex";
import { mapActions, mapState } from "vuex";
export default {
  props: ["datos"],
  data() {
    return {
      shouldReload: false,
      fields: [
        { label: "#", key: "index" },
        { label: "Número", text: "numero", key: "number", sortable: false },
        { label: "fecha", text: "fecha", key: "date_of_issue" },
        { label: "ruc/dni", text: "ruc/dni", key: "customer_number" },
        { label: "Cliente", text: "Cliente", key: "customer_name" },
        { label: "Moneda", text: "Moneda", key: "currency_type_id" },
        { label: "monto", text: "monto", key: "total", sortable: false },
        {
          label: "estado",
          text: "estado",
          key: "state_type_description",
          sortable: false,
        },
        { text: "pdf", key: "actions", sortable: false },
      ],
      datosFacturacion: [],
      customers: [],
    };
  },
  watch: {
    // filtrodatospro: {
    //   handler() {
    //     // this.Cargarfiltrarpro();
    //         //console.log("Los datos se han actualizado en la otra pestaña.");
    //         //console.log(this.filtrodatospro);
    //   },
    //   deep: true,
    // },
  },
  computed: {
    ...mapState(["filtrodatospro"]),
  },
  mounted() {
    this.Cargarfiltrarpro();
  },
  methods: {
    ...mapActions(["filtrarpro"]),
    //...mapMutations(["setfiltrodatospro"]),
    async cargarlistarPro() {
      await this.listarpro();
    },
    async cargarDatosFacturacion() {
      await this.actionsdatosfactura();
    },
    async Cargarfiltrarpro() {
      await this.filtrarpro();
      // await this.setfiltrodatospro(this.filtrodatospro);
      //console.log(this.filtrodatospro);
    },
  },
};
</script>
<style scoped>
.bold-header {
  font-weight: bold; /* Aplica negrita al encabezado */
}
</style>
